module.exports = __webpack_public_path__ + "img/w3_logout_light.acf39c3c.png";